import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

var commonCtl = require("ts-common-react-controls");
var tr = require('ts-translate-js').default.boundTR;
var _ = require('lodash');
var tsRest = require('ts-rest-client');

export const SaleQuestionnaireList = createClass({
    displayName: "SaleQuestionnaireList",

    propTypes: {
        eventID: PropTypes.number,
        formID: PropTypes.string,
        onContentChange: PropTypes.func
    },

    getInitialState() {
        return {
            questionnaireResults: [],
            items: [],
            processing: false,
            page: 0,
            sortBy: [],
            fields: {
                id: { title: "", isKey: true, visible: false },
                lastName: { title: tr("salequestionnaire.lastname") },
                firstName: { title: tr("salequestionnaire.firstname") },
                priceName: { title: tr("salequestionnaire.challenge") },
                Actions: {
                    filter: false,
                    getContent: function() {}
                }
            },
            currentPage: 0,
            filterText: "",
            selectedChallenge: -1,
            searchText:""
        };
    },
    
    componentDidMount() {
        this.loadQuestionnaireResults();
        this.raiseContentChanged();
    },

    componentDidUpdate () {
        this.raiseContentChanged(); // TODO : Devrait peut etre juste être triggered dans la fin du render avec un setTimeout....
    },
    
    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },
    
    loadQuestionnaireResults() {
        this.setState({ processing: true });
        this.loadQuestionnaireResults = tsRest.get("events/" + this.props.eventID + "/forms/" + this.props.formID + "/salequestionnaires/values", { noCache: true })
                                                .done((data) => this.loadQuestionnaireResults_Success(data));
    },

    loadQuestionnaireResults_Success(data) {
        var kmFilter = /(^|.*\s)(\d{1,2})\s?(KM).*/gi; 

        _.forEach(data, (val) => { val.priceName = val.priceName.replace(kmFilter, "$2km"); });

        data = _.orderBy(data, [val => val.lastName.toLowerCase(), val => val.firstName.toLowerCase()]);
        
        this.setState({ "questionnaireResults" : data, processing: false });
    },
    
    componentWillUnmount() {
        if(this.loadQuestionnaireResults != null) this.loadQuestionnaireResults.abort();
    }, 

    // TOCHECK
    // getForm() {
    //     return _.head(_.filter(saleQuestionnaireForm.ticketForms, "id" == this.props.formID));
    // },
    
    handleFilterTextChange: function() {
        
        var val = "";

        if(this.state.searchText != "")
            val += this.state.searchText;
        
        if(this.state.selectedChallenge != -1)
            val += " " + this.state.selectedChallenge;
        
        
        this.setState({ filterText: val });
    },

    handleSearchTextChange(e) { this.setState({ searchText: e.target.value }, this.handleFilterTextChange); },

    handleChallengeChange(e) { this.setState({ selectedChallenge: e.target.value }, this.handleFilterTextChange); },
    
    getDefaultOptionCtl(label) { return (<option key="-1" value="-1">{label}</option>); },
    
    render(){

        var content = null;
        var challengeOptions = null;
        var numberOfParticipants = 0;

        // challenge options
        var challenges = ["1km", "5km", "10km"];
        challengeOptions = _.map(challenges, (y) => <option key={y} value={y}>{y}</option>);
        challengeOptions.unshift(this.getDefaultOptionCtl(tr("salequestionnaire.challenge")));
        
        if(this.state.questionnaireResults.length > 0) {


            numberOfParticipants = this.state.questionnaireResults.length;

            content = <commonCtl.ItemTable
                    fields={this.state.fields}
                    items={this.state.questionnaireResults} 
                    filterText={this.state.filterText}
                    itemPerPage={50}
                    processing={this.state.processing}/>;
        }
        
        return (
            <div className="container-fluid">
                <div className="saleQuestionnaireList">
                    <h3>
                        {tr("Participants confirmés")}
                    </h3>
                    <div className="well text-center alert-warning">
                        ** {tr("IMPORTANT")} **
                        <br />{tr("Si vous ne voyez pas votre nom dans la liste et que vous vous êtes inscrit en ligne") + ","}
                        <br />{tr("veuillez envoyer un courriel à ")}<a href='mailto:info10kmul@sas.ulaval.ca' style={{textDecoration:'underline'}} >info10kmul@sas.ulaval.ca</a>
                    </div>

                    <div className="row">
                        <div className="col-xs-6">
                            <div className="input-group col-xs-12">
                                <ul className="list-inline">
                                    <li>
                                        <select className="form-control" value={this.state.selectedChallenge} onChange={this.handleChallengeChange}>
                                            {challengeOptions}
                                        </select>
                                    </li>
                                    
                                    <li>
                                        <input className="form-control" name="" type="text" autoFocus onFocus={this.handleSearchTextFocus} ref="programSearchInput" onChange={this.handleSearchTextChange} placeholder={tr("recherche")} />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xs-6 text-right">
                            <h5>
                                <strong>
                                    {tr("Nombre de participants") + tr(":")}{numberOfParticipants}
                                </strong>
                            </h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});
